const eventNameMapping = {
  mopping_event: 'Mopping Activity',
  mopping_session_event: 'Mopping Session',
  transit_event: 'Transit',
  no_activity_event: 'No Activity',
  water_fill_event: 'Water Fill',
  non_event: 'Other Tasks',
  arrival_event: 'Arrival',
  departure_event: 'Departure',
  water_change_event: 'Water Change',
  location_change_event: 'Arrival',
  no_activity_session: 'No Activity',
  wringer_removal: 'Wringer Removal',
  wringer_attachment: 'Wringer Attachment',
  water_fill: 'Water Fill',
};

export default eventNameMapping;
